import { Layout, LayoutProps } from "@/Layout";
import PageSkeleton from "../page-skeleton";

export const LayoutLoading = ({
  showNavMain = false,
  showNavSearch = false,
  showTeamSwitcher = false,
  showTeamTrial = false,
  ...props
}: LayoutProps) => {
  return (
    <Layout
      showNavMain={showNavMain}
      showNavSearch={showNavSearch}
      showTeamSwitcher={showTeamSwitcher}
      showTeamTrial={showTeamTrial}
      {...props}
    >
      <PageSkeleton className="p-4" />
    </Layout>
  );
};
